import { includes } from 'lodash'
import { formatDateYMD, processDateRange } from '../Shared/timeutils'

const secondScreens = ['ContentDetails', 'UserDetails', 'AdminDetails', 'AlertDetails', 'SmsHistory']

const PROD_DEMO_ACCOUNT_IDS = [
  '580a3304293bd651571ba542', // Caesars Demo
  '569f94750ca3274b2936f5f3', // Sales Demo Account 1
  '56b9e2320ca3274b2936f624', // Sales Demo 3
  '59b15feed19bb50f37a79ff1', // myNorthwell Demo
  '59cd2cdf282bf20f3176058a', // Rue21 Demo
  '5682c7b90ca3274b2936f564' // CaesarsToday Prod
]

export const getDateFilter = (dateFilterStore, name) => {
  let previousScreen
  let currentScreensDateFilter
  if (dateFilterStore) {
    previousScreen = dateFilterStore.currentComponent
    currentScreensDateFilter = dateFilterStore.screens
    if (secondScreens.indexOf(name) !== -1) {
      return currentScreensDateFilter[previousScreen]
    } else {
      return currentScreensDateFilter[name]
    }
  }
}

export const getGroupFilter = (dateFilterStore, name) => {
  let previousScreen
  let currentScreensDateFilter
  if (dateFilterStore) {
    previousScreen = dateFilterStore.currentComponent
    currentScreensDateFilter = dateFilterStore.screens
    if (secondScreens.indexOf(name) !== -1) {
      return currentScreensDateFilter[previousScreen] && currentScreensDateFilter[previousScreen].groupFilter
    } else {
      return currentScreensDateFilter[name] && currentScreensDateFilter[name].groupFilter
    }
  }
}

export const formatStartEndDates = (date) => {
  return { start: date.start.toISOString(), end: date.end.toISOString() }
}

export const processDate = (dateFilter, id) => {
  let start = new Date()
  let end = new Date()
  // HACK hard set the minutues of demo accounts so that we can cache data during demos.
  const hardSetMinutes = includes(PROD_DEMO_ACCOUNT_IDS, id)
  if (hardSetMinutes) end.setMinutes(45, 0, 0)

  let temp = null
  switch (dateFilter) {
    case 'Day':
      start.setDate(start.getDate() - 1)
      if (hardSetMinutes) {
        start.setMinutes(45, 0, 0)
      } else {
        // when filtering by day the start day indicate the beginning of that particular day
        const newStart = formatDateYMD(start) + 'T23:59:59+0000'
        start = new Date(newStart)
      }
      return { start, end }
    case 'Week':
      start.setDate(start.getDate() - 7)
      start = new Date(formatDateYMD(start) + 'T00:00:00+0000')
      if (hardSetMinutes) start.setMinutes(45, 0, 0)
      return { start, end }
    case 'Month':
      start.setMonth(start.getMonth() - 1)
      start = new Date(formatDateYMD(start) + 'T00:00:00+0000')
      if (hardSetMinutes) start.setMinutes(45, 0, 0)
      return { start, end }
    case 'Custom':
      start.setDate(start.getDate() - 7)
      if (hardSetMinutes) start.setMinutes(45, 0, 0)
      return { start, end }
    default:
      temp = processDateRange(dateFilter)
      start = new Date(temp.start + 'T00:00:00+0000')
      if (hardSetMinutes) start.setMinutes(45, 0, 0)
      end = new Date(temp.end + 'T23:59:59+0000')
      if (hardSetMinutes) end.setMinutes(45, 0, 0)
      return { start, end }
  }
}

export const processGroup = (gFilter) => {
  if (typeof gFilter !== 'string') {
    if (gFilter.profiles && gFilter.profiles.length === 0) {
      gFilter.profiles = ''
    }
    if (gFilter.groups && gFilter.groups.length === 0) {
      gFilter.groups = ''
    }
    if (gFilter.alt && gFilter.alt.length === 0) {
      gFilter.alt = false
    }
    return gFilter
  }
  const f = gFilter.split('_')
  if (f[0]) {
    f[0] = f[0].split('-')
  }
  if (f[1]) {
    f[1] = f[1].split('-')
  }
  return { profiles: f[0], groups: f[1], alt: f[2] }
}

export const composeFilterString = (pFilter, gFilter) => {
  return (pFilter ? pFilter.join('-') : '') + '_' + (gFilter ? gFilter.join('-') : '')
}
